<template>
    <div class="retain-modal" v-if="visible">
        <div class="retain-modal-content">
            <div class="retain-modal-pic"></div>
            <div class="retain-txt-wrap">
                <div class="retain-modal-txt">恭喜你获得1次</div>
                <div class="retain-modal-txt"><span class="highlight">直面互联网大厂</span>的机会</div>
                <div class="retain-modal-desc">不筛简历 · 直通大厂 · 业务直面</div>
                <!-- <div class="retain-modal-desc">10+门训练营无门槛使用</div> -->
                <!-- <div class="retain-modal-desc">直通大厂面试 · 100+专栏免费</div>
                <div class="retain-modal-desc no-margin">300+公开课免费看 · 20+小班课</div> -->
            </div>
            <div class="receive-btn" @click.stop="receive">立即领取</div>
            <div class="reject-btn" @click.stop="closeModal">残忍拒绝</div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RetainModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        pageId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
           count : localStorage.getItem('modalCount_'+this.pageId) || 0
        }
    },
    watch: {
        visible(newValue, oldValue) {
            let count = parseInt(this.count);
            if(newValue && count<=3){
                localStorage.setItem('modalCount_'+this.pageId,count+=1);
            }
        }
    },
    methods: {
        closeModal() {
            this.visible = false
            this.eduPlatTrack('WebButtonClick', {
                'page_id': this.pageId,
                'button_name': '残忍拒绝'
            });
            window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
        },
        receive() {
            this.visible = false
            this.$emit('removeHash')
            this.eduPlatTrack('WebButtonClick', {
                'page_id': this.pageId,
                'button_name': '立即领取'
            });
            // const path = `https://kaiwu.lagou.com/coupon/receive?couponId=DDA33DFB1F51675A2C303C42F24B4483&origin_page_id=${this.pageId}`
            const path = `https://kaiwu.lagou.com/course/courseInfo.htm?courseId=1154&decorateId=24655e625ec0496fbc86d92e88c06977&origin_page_id=${this.pageId}#/sale`
            window.location.href = `lgedu://lgedu.com/h5/open?hideTitle=0&url=${encodeURIComponent(path)}`;
        }
    },
}
</script>

<style lang="less" scoped>
.retain-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background-color: rgba(0, 0, 0, .7);
    .retain-modal-content {
        position: relative;
        top: 50%;
        left: 50%;
        width: 600px;
        height: 550px;
        background-color: #fff;
        border-radius: 8px;
        transform: translate(-50%, -50%);
        .retain-modal-pic {
            position: absolute;
            top: -169px;
            left: 77px;
            width: 447px;
            height: 292px;
            background: url('../../assets/images/retain_modal_pic2@2x.png') no-repeat center;
            background-size: 447px 292px;
        }
        .retain-txt-wrap {
            float: left;
            width: 100%;
            margin-top: 140px;
            .retain-modal-txt {
                width: 100%;
                text-align: center;
                font-size: 36px;
                font-weight: 700;
                color: #333;
                height: 48px;
                line-height: 48px;
                .highlight {
                    color: #FF7452;
                }
            }
            .retain-modal-desc {
                float: left;
                width: 100%;
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: 28px;
                color: #999;
                margin-top: 20px;
                font-weight: 400;
                &.no-margin {
                    margin: 0;
                }
            }
        }
        .receive-btn {
            float: left;
            width: 480px;
            height: 88px;
            line-height: 88px;
            background-color: #FCD766;
            border-radius: 4px;
            font-size: 32px;
            font-weight: 700;
            color: #333;
            text-align: center;
            margin: 60px 0 0 60px;
        }
        .reject-btn {
            float: left;
            width: 480px;
            height: 88px;
            line-height: 88px;
            border-radius: 4px;
            font-size: 32px;
            font-weight: 400;
            color: #666;
            text-align: center;
            margin: 8px 0 0 60px;
        }
    }
}

</style>